
import Vue from 'vue'
import { VCard, VCardText } from 'vuetify/lib'
import JcdcHeadline from '@/components/jcdc/JcdcHeadline.vue'
import JcdcBtn from '@/components/jcdc/JcdcBtn.vue'

interface cardList {
  title: string
  subtitle?: string
  description?: string
  href?: string // External Link
  to?: string // Internal Link
  linkText?: string
}

export default Vue.extend({
  components: {
    VCard,
    VCardText,
    JcdcBtn,
    JcdcHeadline,
  },
  props: {
    title: { type: String, default: 'Title' },
    itemList: {
      type: Array as () => Array<cardList>,
      default: (): [] => [],
    },
  },
})
